import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getTipoTransferencia, cadastrarTipoTransferencia, alterarTipoTransferencia, excluirTipoTransferencia } from './tipos_transferencias_service';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
export var TiposTransferenciasAlterar = function () {
    var services = {
        getItem: getTipoTransferencia,
        cadastrarItem: cadastrarTipoTransferencia,
        alterarItem: alterarTipoTransferencia,
        excluirItem: excluirTipoTransferencia,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.TIPOS_TRANSFERENCIAS, paginaPermissao: FUNCIONALIDADES.TIPOS_TRANSFERENCIAS, rota: ROUTES.TIPOS_TRANSFERENCIAS, services: services });
};
export default TiposTransferenciasAlterar;
